<template>
  <div>
    <section class="main-content">

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>{{songView.title}}</span></h3>
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                  <div class="articles-items">
                                      <div class="articles-box topic-box">
                                        <div class="text">
                                          <!--<h4 class="title text-primary text-center"></h4>-->
                                            <article class="article-editor">
                                                <p v-html="songView.context"></p>
                                            </article>
                                        </div>
                                    </div>
                                  </div>

                                  <div class="articles-items">
                                      <div class="articles-box topic-box">
                                        <div class="text">
                                          <h4 class="title text-primary text-center">{{songView.author}}經典片段</h4>
                                          <div class="row">
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link2"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link3"></iframe>
                                                    </div>
                                                    <blockquote class="blockquote article-blockquote">
                                                    </blockquote>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link4"></iframe>
                                                    </div>
                                                </div>
                                              </div>

                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link5"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link6"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link7"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link8"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-sm-4">
                                                <div class="articles-box videoshare-box">
                                                    <div class="embed-responsive embed-responsive-16by9">
                                                        <iframe class="embed-responsive-item" :src="songView.link9"></iframe>
                                                    </div>
                                                </div>
                                              </div>
                                          </div>
                                        </div>
                                    </div>
                                  </div>
                                  <div class="btn-mid-style">
                                      <router-link class="btn btn-primary btn-sm" v-bind:to="'/topic/'">回婚禮主題表單</router-link>
                                  </div>

                                </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h4 class="title text-primary text-center">{{songView.author}}歌單</h4>
                            <!--<h3 class="title"><span></span></h3>-->
                            <div class="articles-items">
                                <p v-html="songView.lyric"></p>
                            </div>
                        </div>
                        <div class="fb-like" :data-href="'https://www.weddingsung.com/songs/'+songView.id" data-layout="standard" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>
                        <Fbcomment :videoId="songView.id"></Fbcomment>
                    </div>
                </div>
            </div>
        </div>

    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Fbcomment from '../components/Fbcomment.vue'
import Qs from 'qs'
export default {
  name: 'topicview',
  data () {
    return {
      uri: this.$store.getters.getUri,
      userId: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      songId: 0,
      songView: Object,
      name: '',
      link: '',
      context: ''
    }
  },
  components: {
    Fbcomment
  },
  computed: {
    ...mapGetters([
      'getUri'
    ])
  },
  created: function () {
    this.songId = this.$route.params.id
    let self = this
    let dataPost = Qs.stringify({
      token: this.token,
      song_id: this.songId
    })
    self.$http.post(this.uri + 'Song/get_song/', dataPost).then(function (res) {
      let data = res.data
      if (data.status === 200) {
        self.songView = data.song
      } else {
        console.log('fail')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// TopicView.vue?72220ca4